var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-ons-page',{staticClass:"startapp"},[(_vm.isLoading)?_c('SpinnerLoader',{attrs:{"spinnerText":"Signing in"}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }